import type { ReactNode } from 'react';
import bgImage from '../assets/bg.webp';

/**
 * The LevelUp brand backdrop: the brand image under a deep slate wash with a
 * soft emerald glow. Onboarding, the workspace home and workspace settings all
 * sit on it, so signing up, landing and managing a workspace look like one
 * product. Content goes in white cards on top. The logo is white-on-dark, so
 * it only ever appears on this backdrop.
 */
export function BrandBackdrop({ children }: { children: ReactNode }) {
  return (
    <div className="relative min-h-screen overflow-x-clip bg-slate-950">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-40"
        style={{ backgroundImage: `url(${bgImage})` }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-slate-950/70 via-slate-950/80 to-slate-950"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 left-1/2 h-[28rem] w-[56rem] -translate-x-1/2 rounded-full bg-emerald-500/10 blur-3xl"
      />
      <div className="relative flex min-h-screen flex-col">{children}</div>
    </div>
  );
}
